import {
  chakra,
  type ChakraProps,
  IconButton,
  type IconButtonProps,
} from '@chakra-ui/react';
import { type HTMLMotionProps, motion } from 'framer-motion';
import type { ComponentProps, ComponentType, RefAttributes } from 'react';

export const MotionIconButton =
  motion.create<Omit<IconButtonProps, 'transition'>>(IconButton);

export type MotionIconButtonProps = ComponentProps<typeof MotionIconButton>;

export type MotionButtonProps = Omit<
  ChakraProps,
  keyof HTMLMotionProps<'button'> | 'transition'
> &
  HTMLMotionProps<'button'> & { inert?: string };

/** A bare motion-enabled <button> with Chakra style props (no Button theme
 *  styling) — native keyboard activation and focus behavior. */
export const MotionButton = motion.create(chakra.button) as ComponentType<
  MotionButtonProps & RefAttributes<HTMLButtonElement>
>;
